import { ShieldCheck, Info, AlertOctagon } from 'lucide-react';

export type LwsBadgeVariant = 'default' | 'caution' | 'blocked';

interface LwsBadgeProps {
  variant?: LwsBadgeVariant;
  note?: string | undefined;
}

const VARIANT_STYLE: Record<
  LwsBadgeVariant,
  { container: string; text: string; iconColor: string; label: string }
> = {
  default: {
    container: 'border-emerald-500 bg-white',
    text: 'text-emerald-700',
    iconColor: 'text-emerald-600',
    label: 'LWS-freundlich',
  },
  caution: {
    container: 'border-amber-500 bg-white',
    text: 'text-amber-700',
    iconColor: 'text-amber-600',
    label: 'LWS-Hinweis',
  },
  blocked: {
    container: 'border-rose-600 bg-white',
    text: 'text-rose-700',
    iconColor: 'text-rose-600',
    label: 'LWS-Risiko',
  },
};

export function LwsBadge({ variant = 'default', note }: LwsBadgeProps): JSX.Element {
  const style = VARIANT_STYLE[variant];
  const Icon = variant === 'default' ? ShieldCheck : variant === 'caution' ? Info : AlertOctagon;
  return (
    <span
      className={`inline-flex h-6 items-center gap-1 rounded-full border px-2 text-xs font-semibold ${style.container} ${style.text}`}
      title={note ?? style.label}
      aria-label={note ? `${style.label}: ${note}` : style.label}
    >
      <Icon aria-hidden="true" className={`size-3.5 ${style.iconColor}`} />
      {style.label}
    </span>
  );
}
